// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1StateSchema } from './v1/stateSchema';

export const listStatesPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const listStatesHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description States retrieved successfully
 */
export const listStates200Schema = z.array(z.lazy(() => v1StateSchema));

export const listStatesQueryResponseSchema = z.lazy(() => listStates200Schema);
